import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const StoreChangePages = {
  list: 'ListStoreChange',
  add: 'AddStoreChange',
  edit: 'EditStoreChange',
}

const { t } = i18n.global

const title = t('pages.listStoreChange')
const path = '/store-change'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: StoreChangePages.add,
  component: () => import('@/pages/mainPageWithRoute/store-change/AddStoreChangePage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: StoreChangePages.edit,
  component: () => import('@/pages/mainPageWithRoute/store-change/EditStoreChangePage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: StoreChangePages.list,
  component: () => import('@/pages/mainPageWithRoute/store-change/ListStoreChangePage.vue'),
  meta: { title, requiresAuth: true },
}

export const StoreChanges: RouteRecordRaw = {
  path,
  name: 'StoreChanges',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Edit, Add],
}
